// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class LocationDto {
    @AutoMap() locationId: string;
    @AutoMap() address1: string;
    @AutoMap() address2: string;
    @AutoMap() longitude: string;
    @AutoMap() latitude: string;
    @AutoMap() posatlCode: string;
    @AutoMap() city: string;
    @AutoMap() country: string;
    @AutoMap() telephone: string;
    @AutoMap() comment: string;
    @AutoMap() locationTypeId: string;
}